module.exports = __webpack_public_path__ + "img/Vespaio-Map-icon-White.c35e569c.png";